export const LANGUAGE_CREATE_RESET = 'LANGUAGE_CREATE_RESET'
export const LANGUAGE_CREATE_SET_CREATED = 'LANGUAGE_CREATE_SET_CREATED'
export const LANGUAGE_CREATE_SET_ERROR = 'LANGUAGE_CREATE_SET_ERROR'
export const LANGUAGE_CREATE_SET_VIOLATIONS = 'LANGUAGE_CREATE_SET_VIOLATIONS'
export const LANGUAGE_CREATE_TOGGLE_LOADING = 'LANGUAGE_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/language/create/mutation_types.js